import React from "react";

// Slider with optional bipolar text labels (legacy "personality bars"
// like CLASSIC ↔ CONTEMPORARY). When min_label/max_label are set, those
// are shown at the ends instead of the numeric range.
export const SliderField = ({ question, value, onChange, lang }) => {
  const min = question.min_value ?? 0;
  const max = question.max_value ?? 100;
  const step = question.step ?? 1;
  const v =
    value === null || value === undefined || value === ""
      ? Math.round((min + max) / 2)
      : Number(value);

  const minLabel =
    (lang === "ar" && question.min_label_arabic) || question.min_label || "";
  const maxLabel =
    (lang === "ar" && question.max_label_arabic) || question.max_label || "";
  const useTextLabels = !!(minLabel || maxLabel);

  return (
    <div className="dq-slider-row">
      <span
        style={{
          minWidth: 100,
          textAlign: lang === "ar" ? "left" : "right",
          fontWeight: useTextLabels ? 600 : 400,
        }}
      >
        {useTextLabels ? minLabel || min : min}
      </span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={v}
        onChange={(e) => onChange(Number(e.target.value))}
        style={{ flex: 1 }}
      />
      <span
        style={{
          minWidth: 100,
          textAlign: lang === "ar" ? "right" : "left",
          fontWeight: useTextLabels ? 600 : 400,
        }}
      >
        {useTextLabels ? maxLabel || max : max}
      </span>
      {!useTextLabels && <span className="dq-slider-value">{v}</span>}
    </div>
  );
};
